import { StudentProblemResult } from '@yandex-int/k-common/typings';
import b from 'b_';
import { Link as LinkIcon } from 'education-icons';
import { Text, Link } from 'platform-components';
import React from 'react';

import { PROBLEM_DISPLAY_STATUS } from 'common.components/student-lesson-stat/typings';
import { getOpenAnswerUrl } from 'utils/open-answer';

import { StatItem } from '../lesson-content__stat-item-wrapper';

export const OpenAnswerLink = (props: {
    studentProblemResult: StudentProblemResult | null;
    isLessonScoreAvailable: boolean;
}) => {
    const { studentProblemResult, isLessonScoreAvailable } = props;

    const resultLink = getOpenAnswerUrl(studentProblemResult);
    const hasLink = Boolean(resultLink).toString();

    const renderLink = () => {
        if (isLessonScoreAvailable) {
            return (
                <Link mix="lesson-content__stat-detail-link" target="_blank" to={resultLink}>
                    <LinkIcon />
                    <Text id="studentLessonStat.problemLinkText" weight={Text.WEIGHT.M} />
                </Link>
            );
        }

        return (
            <span className="lesson-content__stat-detail-value">
                <Text weight={Text.WEIGHT.L}>&mdash;</Text>
            </span>
        );
    };

    return (
        <StatItem>
            <Text id="studentLessonStat.problemLink" values={{ hasLink }} />
            {resultLink ? (
                renderLink()
            ) : (
                <span
                    className={b('lesson-content', 'stat-detail-marker', {
                        status: PROBLEM_DISPLAY_STATUS.NOT_SEEN,
                    })}
                />
            )}
        </StatItem>
    );
};
